module.exports = __webpack_public_path__ + "87fcb2ec059515d646a066333de865ec.png";